import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  container: FelaCSS;
  title: FelaCSS;
  iframe: FelaCSS;
}

const styles = (): IStyles => ({
  container: {
    margin: `${spacing[16]} ${spacing[0]} ${spacing[8]}`,
    maxWidthTabletSm: {
      margin: `${spacing[10]} ${spacing[4]} ${spacing[6]}`,
    },
  },
  title: {
    color: colors.space,
    fontDefaultSemiBold: 32,
    textAlign: 'center',
    marginBottom: 10,
    lineHeight: '120%',
    maxWidthTabletSm: {
      marginBottom: 4,
      fontSize: 24,
      lineHeight: '140%',
    },
  },
  iframe: {
    borderRadius: 20,
    border: 'none',
    height: 780,
    width: '100%',

    maxWidthTabletSm: {
      height: 228,
      borderRadius: 6,
    },
  },
});

export default styles;
